import { render, staticRenderFns } from "./roleUsers.vue?vue&type=template&id=80e3d1da&"
import script from "./roleUsers.vue?vue&type=script&lang=js&"
export * from "./roleUsers.vue?vue&type=script&lang=js&"
import style0 from "./roleUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports